<template>
  <section class="sub-page iframe">
    <top-section
      :navs="navs"
      :title="nav_title"
    />

    <!-- <div
      v-if="!iframe.loaded"
      class="m-5 p-5 text-center"
    >
      <b-spinner
        class="m-5 p-5"
        variant="success"
        size="12rem"
      />
    </div>

    <iframe
      v-show="iframe.loaded" 
      id="housing__data__dashboard"
      ref="housing__data__dashboard"
      :src="iframe.src"
      scrolling="no"
      title="Housing Data"
      rameborder="0"
      allowFullScreen="true"
      style="width:100%; min-height:1450px; border:0; overflow: hidden;"
      @load="load"
    /> -->
    <div class="my-10 mx-[5%] ">
      <div class="text-center ">
        <p class="font-semibold py-4 text-3xl">
          HMIP | Housing Price Index
        </p>
      </div>
      <div class=" mt-4 justify-between md:flex-row flex flex-col mx-auto">
        <div class="md:w-[30%] w-full ">
          <div
            style="background-color:#f8f8f8;"
            class="bg-[#f8f8f8] p-4 mb-4 rounded-lg"
          >
            <p class="pb-2 text-xl">
              what state do you want to see
            </p>
            <select
              id="fruit"
              name="fruit"
              class="w-4/6  rounded-lg p-2"
            >
              <option value="apple">
                Apple
              </option>
              <option value="banana">
                Banana
              </option>
              <option value="orange">
                Orange
              </option>
              <option value="grape">
                Grape
              </option>
            </select>
          </div>
          <div
            style="background-color:#f8f8f8;"
            class="bg-[#f8f8f8] p-4 mb-4 rounded-lg"
          >
            <p class="pb-2 text-xl">
              Select Year
            </p>
            <select
              id="fruit"
              name="fruit"
              class="w-4/6 rounded-lg p-2"
            >
              <option value="apple">
                2001
              </option>
              <option value="banana">
                2002
              </option>
              <option value="orange">
                2003
              </option>
              <option value="grape">
                2004
              </option>
            </select>
          </div>
          <div
            style="background-color:#f8f8f8;"
            class="bg-[#f8f8f8] p-4 mb-4 rounded-lg"
          >
            <p class="pb-2 text-xl">
              Select Quarter
            </p>
            <select
              id="fruit"
              name="fruit"
              class="w-4/6 rounded-lg p-2"
            >
              <option value="apple">
                q1
              </option>
              <option value="banana">
                q2
              </option>
              <option value="orange">
                q3
              </option>
              <option value="grape">
                q4
              </option>
            </select>
          </div>
          <div
            style="background-color:#f8f8f8;"
            class="bg-[#f8f8f8] p-4 mb-4 rounded-lg"
          >
            <p class="pb-2 text-lg">
              How many bedrooms are you seeking
            </p>
            <select
              id="fruit"
              name="fruit"
              class="w-4/6 rounded-lg p-2"
              aria-placeholder="Number of Bedrooms"
            >
              <option value="apple">
                1
              </option>
              <option value="banana">
                2
              </option>
              <option value="orange">
                3
              </option>
              <option value="grape">
                4
              </option>
            </select>
          </div>
          <div
            style="background-color:#f8f8f8;"
            class="bg-[#f8f8f8] p-4 mb-4 rounded-lg"
          >
            <p class="pb-2 text-xl">
              Which area or town do you want to see?
            </p>
            <select
              id="fruit"
              name="fruit"
              class="w-4/6 rounded-lg p-2"
              aria-placeholder="Area or Town"
            >
              <option value="apple">
                Abuja
              </option>
              <option value="banana">
                Buari
              </option>
              <option value="orange">
                Kuje
              </option>
              <option value="grape">
                Gwarimpa
              </option>
            </select>
          </div>
        </div>
   
        <div class="md:w-[65%] w-full">
          <div
            style="background-color:#fffeed;"
            class="flex flex-wrap justify-between p-4 bg-[#fffeed] rounded-lg "
          >
            <div class="md:w-[30%] w-full ">
              <p>
                What is the Price of the most expensive house in the selected area?
              </p>
              <p class="pt-4 font-bold text-2xl">
                N147.17m
              </p>
            </div>
            <div class="w-[0.5px] bg-[#f1ede7]" />
            <div class="md:w-[30%] w-full ">
              <p>What is the average prices of the houses in the selected area? </p>
              <p class="pt-8 font-bold text-2xl">
                N13.17m
              </p>
            </div>
            <div class="w-[0.5px] bg-[#f1ede7]" />
            <div class="md:w-[30%] w-full ">
              <p>
                What is the Price of the most cheapest house in the selected area?
              </p>
              <p class="pt-4 font-bold text-2xl">
                N72.17m
              </p>
            </div>
          </div>
      
          <div class="my-10 flex items-end gap-10">
            <div class="bg-[#fff5f5] p-4 rounded-lg w-2/5">
              <p class="pb-4">
                What is the performance of price Change per quarter?
              </p>
              <div class="flex justify-center">
                <img
                  src="/theme-assets/images/Chart14.png"
                  alt=""
                  class="w-48 h-40 items-center"
                >
              </div>
            </div>
      
            <!-- bipolar chart -->
            <div class="p-4 bg-[#edf5ff] pt-0 w-2/3 rounded-lg">
              <img
                src="/theme-assets/images/BI-POLARBARCHART.png"
                alt=""
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TopSection from '../../components/General/TopSection.vue'

export default {
    name: 'HousingDashboard',
    components: { TopSection },

    data: () => ({
        nav_title: 'Datasets',
        navs: [
            {
                route_name: 'home',
                route_title: 'Home',
            },
            {
                route_name: 'dashboard',
                route_title: 'Dashboards',
            },
            {
                route_name: 'dashboard.housing',
                route_title: 'Housing Statistics Dashboard',
                active: true,
            },
        ],
        visible: true,
        iframe: {
            src: 'https://app.powerbi.com/view?r=eyJrIjoiNmNiNmI1MzMtYjI5ZS00ZmUwLThlNTUtYjdiMTU3YmRjNDhmIiwidCI6ImE4MTNjYTk4LWU0MTMtNDJkMS1iNzNmLTlmZGM3YTJhYjhkNCIsImMiOjh9',
            loaded: false
        }
    }),

    methods: {
      load() {
        this.iframe.loaded = true;
      },
    },
}
</script>
<style scoped>
.iframe {
  overflow-y: hidden;
}
</style>

